import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=1791cfad&"
import script from "./DataForm.vue?vue&type=script&lang=js&"
export * from "./DataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports